export function randomColorWithoutRepetition(
  colors: string[],
  defaultColor: string,
) {
  if (colors.length === 0) {
    return defaultColor;
  }
  const randomIndex = Math.floor(Math.random() * colors.length);
  const color = colors[randomIndex];
  colors.splice(randomIndex, 1);
  return color;
}
